











































































import { Component } from 'vue-property-decorator'
import {
  LeadFeedbackTags, $newObj, LeadFeedbackStatus,
  CustomerLeadFeedbackModel, ICustomerLeadFeedbackModel, LeadCustomerEvaluation
} from '@immosparrow/cockpit-api-v2'
import { OptionModel } from '@/models/global'
import { mixins } from 'vue-class-component'
import GlobalMixin from '@/mixins/GlobalMixin'

@Component({
  inject: ['$validator']
})
export default class Feedback extends mixins(GlobalMixin) {
  get feedbackData () {
    return this.$store.getters.feedbackData
  }

  get lead () {
    return this.feedbackData.lead || {}
  }

  get like () {
    return this.feedbackData.status
  }

  properties: OptionModel[] = []
  feedbackTags: OptionModel[] = []
  feedback: ICustomerLeadFeedbackModel = $newObj(CustomerLeadFeedbackModel)
  sendingFeedback = false

  get title () {
    return this.lead?.publication?.primaryInfo?.basicInfo?.title
  }

  get image () {
    if (this.lead?.publication?.pictures?.length) {
      return this.generateImageUrl(this.lead.publication.pictures[0].id)
    }
    return '/img/house-placeholder.png'
  }

  get sortedTags () {
    return this.properties.sort((a, b) => (a.value as number) - (b.value as number))
  }

  created () {
    this.initForm()
  }

  addTag (tag: OptionModel, index: number) {
    if (!this.feedbackTags.includes(tag)) {
      this.properties.splice(index, 1)
      this.feedbackTags.push(tag)
    }
  }

  removeTag (tag: OptionModel, index: number) {
    this.feedbackTags.splice(index, 1)
    this.properties.push(tag)
  }

  async updateLeadStatus () {
    const res = await this.$validator.validateAll()
    if (!res) return
    this.sendingFeedback = true
    this.feedback.leadId = this.lead.id as string
    this.feedback.evaluation = this.like ? LeadFeedbackStatus.Like : LeadFeedbackStatus.Dislike
    if (this.feedbackTags.length) {
      this.feedbackTags.forEach(item => {
        if (!this.feedback.feedbackTags) {
          this.feedback.feedbackTags = []
        }
        this.feedback.feedbackTags.push(LeadFeedbackTags[item.value])
      })
    }
    await this.$store.dispatch('updateLeadStatus', this.feedback)
    this.$root.$emit('updateLeadStatus', this.lead.id, this.like)
    this.sendingFeedback = false

    if (!this.lead.customerEvaluation) this.lead.customerEvaluation = $newObj(LeadCustomerEvaluation)
    this.lead.customerEvaluation.evaluation = this.like ? LeadFeedbackStatus.Like : LeadFeedbackStatus.Dislike
    this.$emit('update:lead', this.lead)
    this.initForm()
    this.$bvModal.hide(`modal-${this.lead.id}`)
  }

  initForm () {
    this.properties = [
      { text: 'Amenities', value: LeadFeedbackTags.Amenities },
      { text: 'Location', value: LeadFeedbackTags.Location },
      { text: 'Price', value: LeadFeedbackTags.Price },
      { text: 'Condition', value: LeadFeedbackTags.ObjectCondition },
      { text: 'Other', value: LeadFeedbackTags.Other }
    ]
    this.feedback = $newObj(CustomerLeadFeedbackModel)
    this.feedbackTags = []
  }
}
